import { render } from "./LoaderFittingIntoContainer.vue?vue&type=template&id=6301f018&scoped=true"
const script = {}

import "./LoaderFittingIntoContainer.vue?vue&type=style&index=0&id=6301f018&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6301f018"]])

export default __exports__